import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Box, Container, Heading, HStack, Icon, Link, Stack, Text } from "@chakra-ui/react";
import { MdEmail, MdPhone } from "react-icons/md";

import { CallToAction } from "../components/marketing-layout/CallToAction";
import { ContactUsDetails } from "../components/marketing-layout/ContactUsDetails"
import { MarketingLayout } from "../components/marketing-layout";
import { useCmsApi } from "../services/useCmsApi";

const DirectContactBar = ({ email, phone }: { email: string; phone: string }) => (
	<Box bg="green.700" py="4">
		<Container maxW="1560px">
			<Stack
				direction={{ base: "column", sm: "row" }}
				spacing={{ base: "3", sm: "10" }}
				justify="center"
				align="center"
			>
				<HStack spacing="2" color="white">
					<Icon as={MdEmail} boxSize="5" />
					<Link href={`mailto:${email}`} color="white" fontWeight="semibold" fontSize="sm">
						{email}
					</Link>
				</HStack>
				<HStack spacing="2" color="white">
					<Icon as={MdPhone} boxSize="5" />
					<Link href={`tel:${phone.replace(/\s/g, "")}`} color="white" fontWeight="semibold" fontSize="sm">
						{phone}
					</Link>
				</HStack>
			</Stack>
		</Container>
	</Box>
);

export const MarketingContactUs = () => {
	const { t } = useTranslation();
	const cmsApi = useCmsApi();
	const [contactEmail, setContactEmail] = useState("info@geco-ag.com");
	const [contactPhone, setContactPhone] = useState("+1 604 809 0430");

	useEffect(() => {
		let cancelled = false;
		cmsApi.getSiteSettings().then((settings) => {
			if (cancelled) return;
			for (const s of settings) {
				if (s.key === "contactEmail") setContactEmail(s.value);
				if (s.key === "contactPhone") setContactPhone(s.value);
			}
		});
		return () => { cancelled = true; };
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	return (
        <MarketingLayout>
			<>
				<CallToAction
					headingTitle={t("contactUs.ctaTitle")}
					headingDescription={t("contactUs.ctaDescription")}
					ctaImageUrl="contact-background-field.png"
					ctaImageAlt={t("contactUs.ctaImageAlt") || "Get Started Image"}
				/>
				<DirectContactBar email={contactEmail} phone={contactPhone} />
				<ContactUsDetails />
			</>
        </MarketingLayout>
	);
};
